import {Box} from '@mui/material';
import styled from 'styled-components';

const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 16px;
		border-radius: 8px;
		background-color: ${({theme}) => theme.colors.light.background.paper};
	}
`;

export {StyledBox};
